module.exports = __webpack_public_path__ + "static/media/Nazar.136f0e82.jpg";